/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ConnectStartView } from '../model/connectStartView';
import { ConnectionSiteView } from '../model/connectionSiteView';
import { ConnectorErrorResponse } from '../model/connectorErrorResponse';
import { ConsentMailRequest } from '../model/consentMailRequest';
import { CreateConnectionRequest } from '../model/createConnectionRequest';
import { ExternalConnectionView } from '../model/externalConnectionView';
import { SitePermissionSessionStartView } from '../model/sitePermissionSessionStartView';
import { SitePermissionSessionView } from '../model/sitePermissionSessionView';
import { SiteProjectsRequest } from '../model/siteProjectsRequest';
import { SiteSelectionRequest } from '../model/siteSelectionRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ExternalConnectionControllerService {

    protected basePath = 'https://api.beta.planbic.de';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Verbindung trennen; mit freigegebenen Sites über Login-URL eines SharePoint-Admins
     * 
     * @param id 
     * @param connectionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public disconnectExternalConnection(id: number, connectionId: string, observe?: 'body', reportProgress?: boolean): Observable<SitePermissionSessionStartView>;
    public disconnectExternalConnection(id: number, connectionId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SitePermissionSessionStartView>>;
    public disconnectExternalConnection(id: number, connectionId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SitePermissionSessionStartView>>;
    public disconnectExternalConnection(id: number, connectionId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling disconnectExternalConnection.');
        }

        if (connectionId === null || connectionId === undefined) {
            throw new Error('Required parameter connectionId was null or undefined when calling disconnectExternalConnection.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SitePermissionSessionStartView>('post',`${this.basePath}/organisations/${encodeURIComponent(String(id))}/connections/${encodeURIComponent(String(connectionId))}/disconnect`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Stand einer Sitzung: verfügbare Sites oder Ergebnis
     * 
     * @param id 
     * @param connectionId 
     * @param sessionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSitePermissionSession(id: number, connectionId: string, sessionId: string, observe?: 'body', reportProgress?: boolean): Observable<SitePermissionSessionView>;
    public getSitePermissionSession(id: number, connectionId: string, sessionId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SitePermissionSessionView>>;
    public getSitePermissionSession(id: number, connectionId: string, sessionId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SitePermissionSessionView>>;
    public getSitePermissionSession(id: number, connectionId: string, sessionId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getSitePermissionSession.');
        }

        if (connectionId === null || connectionId === undefined) {
            throw new Error('Required parameter connectionId was null or undefined when calling getSitePermissionSession.');
        }

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling getSitePermissionSession.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SitePermissionSessionView>('get',`${this.basePath}/organisations/${encodeURIComponent(String(id))}/connections/${encodeURIComponent(String(connectionId))}/site-sessions/${encodeURIComponent(String(sessionId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Verbindungen der Organisation mit Sites und Projektzuordnung
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listExternalConnections(id: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ExternalConnectionView>>;
    public listExternalConnections(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ExternalConnectionView>>>;
    public listExternalConnections(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ExternalConnectionView>>>;
    public listExternalConnections(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling listExternalConnections.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ExternalConnectionView>>('get',`${this.basePath}/organisations/${encodeURIComponent(String(id))}/connections`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Neue Zustimmungs-URL per Mail an die IT schicken (die bisherige wird ungültig)
     * 
     * @param body 
     * @param id 
     * @param connectionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendExternalConnectionConsentMail(body: ConsentMailRequest, id: number, connectionId: string, observe?: 'body', reportProgress?: boolean): Observable<ConnectStartView>;
    public sendExternalConnectionConsentMail(body: ConsentMailRequest, id: number, connectionId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ConnectStartView>>;
    public sendExternalConnectionConsentMail(body: ConsentMailRequest, id: number, connectionId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ConnectStartView>>;
    public sendExternalConnectionConsentMail(body: ConsentMailRequest, id: number, connectionId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling sendExternalConnectionConsentMail.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling sendExternalConnectionConsentMail.');
        }

        if (connectionId === null || connectionId === undefined) {
            throw new Error('Required parameter connectionId was null or undefined when calling sendExternalConnectionConsentMail.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ConnectStartView>('post',`${this.basePath}/organisations/${encodeURIComponent(String(id))}/connections/${encodeURIComponent(String(connectionId))}/consent-mail`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Projekte, die die Site nutzen dürfen (Soll-Stand)
     * 
     * @param body 
     * @param id 
     * @param connectionId 
     * @param connectionSiteId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setExternalSiteProjects(body: SiteProjectsRequest, id: number, connectionId: string, connectionSiteId: string, observe?: 'body', reportProgress?: boolean): Observable<ConnectionSiteView>;
    public setExternalSiteProjects(body: SiteProjectsRequest, id: number, connectionId: string, connectionSiteId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ConnectionSiteView>>;
    public setExternalSiteProjects(body: SiteProjectsRequest, id: number, connectionId: string, connectionSiteId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ConnectionSiteView>>;
    public setExternalSiteProjects(body: SiteProjectsRequest, id: number, connectionId: string, connectionSiteId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setExternalSiteProjects.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling setExternalSiteProjects.');
        }

        if (connectionId === null || connectionId === undefined) {
            throw new Error('Required parameter connectionId was null or undefined when calling setExternalSiteProjects.');
        }

        if (connectionSiteId === null || connectionSiteId === undefined) {
            throw new Error('Required parameter connectionSiteId was null or undefined when calling setExternalSiteProjects.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ConnectionSiteView>('put',`${this.basePath}/organisations/${encodeURIComponent(String(id))}/connections/${encodeURIComponent(String(connectionId))}/sites/${encodeURIComponent(String(connectionSiteId))}/projects`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Verbindung anlegen bzw. neu starten und Zustimmungs-URL erzeugen
     * 
     * @param body 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public startExternalConnection(body: CreateConnectionRequest, id: number, observe?: 'body', reportProgress?: boolean): Observable<ConnectStartView>;
    public startExternalConnection(body: CreateConnectionRequest, id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ConnectStartView>>;
    public startExternalConnection(body: CreateConnectionRequest, id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ConnectStartView>>;
    public startExternalConnection(body: CreateConnectionRequest, id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling startExternalConnection.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling startExternalConnection.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ConnectStartView>('post',`${this.basePath}/organisations/${encodeURIComponent(String(id))}/connections`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sites verwalten: Sitzung starten, Login-URL für einen SharePoint-Admin
     * 
     * @param id 
     * @param connectionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public startSitePermissionSession(id: number, connectionId: string, observe?: 'body', reportProgress?: boolean): Observable<SitePermissionSessionStartView>;
    public startSitePermissionSession(id: number, connectionId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SitePermissionSessionStartView>>;
    public startSitePermissionSession(id: number, connectionId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SitePermissionSessionStartView>>;
    public startSitePermissionSession(id: number, connectionId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling startSitePermissionSession.');
        }

        if (connectionId === null || connectionId === undefined) {
            throw new Error('Required parameter connectionId was null or undefined when calling startSitePermissionSession.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SitePermissionSessionStartView>('post',`${this.basePath}/organisations/${encodeURIComponent(String(id))}/connections/${encodeURIComponent(String(connectionId))}/site-sessions`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Soll-Stand der freigegebenen Sites speichern; Login-URL zum Anwenden
     * 
     * @param body 
     * @param id 
     * @param connectionId 
     * @param sessionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public submitSitePermissionSelection(body: SiteSelectionRequest, id: number, connectionId: string, sessionId: string, observe?: 'body', reportProgress?: boolean): Observable<SitePermissionSessionStartView>;
    public submitSitePermissionSelection(body: SiteSelectionRequest, id: number, connectionId: string, sessionId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SitePermissionSessionStartView>>;
    public submitSitePermissionSelection(body: SiteSelectionRequest, id: number, connectionId: string, sessionId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SitePermissionSessionStartView>>;
    public submitSitePermissionSelection(body: SiteSelectionRequest, id: number, connectionId: string, sessionId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling submitSitePermissionSelection.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling submitSitePermissionSelection.');
        }

        if (connectionId === null || connectionId === undefined) {
            throw new Error('Required parameter connectionId was null or undefined when calling submitSitePermissionSelection.');
        }

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling submitSitePermissionSelection.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SitePermissionSessionStartView>('post',`${this.basePath}/organisations/${encodeURIComponent(String(id))}/connections/${encodeURIComponent(String(connectionId))}/site-sessions/${encodeURIComponent(String(sessionId))}/selection`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
